import { Cart } from '@hiwaldo/sdk/interfaces';
import { getFromLocalStorage } from '../../../../utils';
import { LocalStorageKeys } from '../../../../enums/local-storage-keys';
import { PaymentMethods } from '../../../../data/subscription/payment-methods';

export interface CartState {
  cart: Cart | null;
  countItems: number;
  countProductVariants: number;
  countBundles: number;
  countTrials: number;
  includesTrial: boolean;
  includesBLG: boolean;
  includesDrops: boolean;
  includesDoctor: boolean;
  includesPrescription: boolean;
  includesTax: boolean;
  basketOpen: boolean;
  paymentGateway: PaymentMethods | null;
  paypal: {
    paypalToken: string | null;
    paypalStatus: string | null;
  };
}

export const initialCartState: CartState = getFromLocalStorage(
  LocalStorageKeys.CART_STATE,
  {
    cart: null,
    countItems: 0,
    countProductVariants: 0,
    countBundles: 0,
    countTrials: 0,
    includesTrial: false,
    includesBLG: false,
    includesDrops: false,
    includesDoctor: false,
    includesPrescription: false,
    includesTax: false,
    basketOpen: false,
    paymentGateway: null,
    paypal: {
      paypalToken: '',
      paypalStatus: '',
    },
  }
);
